import { API_URL_V3 } from 'constants/index';
import type { Recipient } from 'models';
import type { FetchResponse } from 'utils/fetchJson/fetchJson';
import { fetchJson } from 'utils/fetchJson/fetchJson';

type OfferResponse = {
  id: string;
  name: string;
  description: string;
  paymentOption: string;
  paymentMethod: string;
};

export interface RecipientsService {
  fetch: (payload: {
    id: string | undefined;
    locale: string;
  }) => Promise<Recipient>;
  fetchBySubdomain: (payload: {
    subdomain: string;
    locale: string;
  }) => Promise<Recipient>;
  fetchOffers: (payload: {
    recipientId: string;
    country: string;
    amount: number;
    fingerprint?: string;
    locale: string;
  }) => Promise<OfferResponse[]>;
  fetchOffer: (payload: {
    recipientId: string;
    country: string;
    id: string;
    locale: string;
  }) => Promise<FetchResponse>;
  fetchCountries: (payload: {
    recipientId: string;
    locale?: string;
  }) => Promise<FetchResponse>;
}

const recipients: RecipientsService = {
  fetch: ({ id, locale }) => {
    if (!id) {
      return Promise.reject(new Error('Recipient ID is undefined'));
    }

    const path = `${API_URL_V3}/recipients/${id}?locale=${locale}`;

    return fetchJson(path);
  },

  fetchBySubdomain: ({ subdomain, locale }) => {
    const path = `${API_URL_V3}/recipients/subdomain/${subdomain}?locale=${locale}`;

    return fetchJson(path);
  },

  fetchOffers: ({ recipientId, country, amount, fingerprint = '', locale }) => {
    if (!amount && amount <= 0) {
      return Promise.resolve([]);
    }

    const path = `${API_URL_V3}/recipients/${recipientId}/countries/${country}/offers?amount=${amount}&fingerprint=${fingerprint}&locale=${locale}`;

    return fetchJson(path);
  },

  fetchOffer: ({ recipientId, country, id, locale }) => {
    const path = `${API_URL_V3}/recipients/${recipientId}/countries/${country}/offers/${id}?locale=${locale}`;

    return fetchJson(path);
  },

  fetchCountries: ({ recipientId, locale = 'EN' }) => {
    const path = `${API_URL_V3}/recipients/${recipientId}/countries?locale=${locale}`;

    return fetchJson(path);
  },
};

export { recipients };
